var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"creditCardIframe",attrs:{"id":"creditCardIframe"}},[_c('form',{staticClass:"paymentWidgets",attrs:{"data-brands":"VISA MASTER AMEX","action":_vm.formAction}})])])}
var staticRenderFns = []

export { render, staticRenderFns }